// extracted by mini-css-extract-plugin
module.exports = {"container":"Title_container__O3mNC","title":"Title_title__m_xlu","titleEmphasis":"Title_titleEmphasis__pqpEE","handMark":"Title_handMark__Dkw8O","subtitle":"Title_subtitle__4RU1p"};